import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { isAllDigitalDelivery } from './utils/cartValidation'
import BillingAddressSection from './BillingAddressSection'
import ShippingAddressSection from './ShippingAddressSection'

const CheckoutAddressDisplay = () => {
  const cartItems = useSelector(state => state.cartItems)
  const youPay = useSelector(state => state.checkout.youPay)
  const requireBillingAddressForFreeOrders = useSelector(
    state => state.storeViews.current.require_billing_address_for_free_orders
  )

  const allDigital = useMemo(() => isAllDigitalDelivery(cartItems), [cartItems])

  // Hide billing section for digital-only carts that don't require billing and youPay is 0
  const hideBillingForDigital = allDigital && !requireBillingAddressForFreeOrders && youPay === 0

  return !hideBillingForDigital && (
    <>
      {!allDigital && <ShippingAddressSection />}
      <BillingAddressSection isDigitalOnly={allDigital} />
    </>
  )
}

export default CheckoutAddressDisplay
